

















































































































import Vue from 'vue'
import ProjectAddressSearch from '@/components/master-data/address/ProjectAddressSearch.vue'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import {
    Konditionen,
  KontenErtrag,
  MitarbeiterBuchnung,
  Steuersaetze,
  Waehrungen
} from '@/types/service-response'
import { ProjectBookingBeleg } from '@/model/project/ProjectBookingBeleg'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import NumberField from '@/components/NumberField.vue'

interface ComponentData {
  validationRules: Array<Function>
  decimalRules: Array<Function>
  menu1: boolean
  dateRules: any[]
  dateFormatted: string | null
  showSearchDialog: boolean
  address: string
}

export default Vue.extend({
  name: 'BookingAssistant12',

  components: {
    ProjectAddressSearch,
    NumberField
  },

  props: {
    value: Object as () => ProjectBookingBeleg,
    kontoList: Array as () => KontenErtrag[],
    mitarbeiterList: Array as () => MitarbeiterBuchnung[],
    versandartList: Array as () => Konditionen[],
    lieferungList: Array as () => Konditionen[],
    zahlungList: Array as () => Konditionen[],
    waehrungList: Array as () => Waehrungen[],
    steuerList: Array as () => Steuersaetze[]
  },

  data (): ComponentData {
    const required = (value: any): boolean => !!value
    const decimalRule = (value: string) => {
          const pattern = /^(\d+(?:[\.\,]\d{1,5})?)$/
          return pattern.test(value) || ''
        }

    return {
      validationRules: [required],
      decimalRules: [decimalRule],
      menu1: false,
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        },

        (value: string) => {
          return !!value
        }
      ],
      dateFormatted: '',
      showSearchDialog: false,
      address: '',
    }
  },

  watch: {
    dateFormatted (newVal: string): void {
      if(newVal) {
        this.data.Konditionen.Datum = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.data.Konditionen.Datum = ''
      }
    }
  },

  computed: {
    data: {
      get(): ProjectBookingBeleg {
        return this.value
      },

      set(val: any): void {
        this.$emit('input', val)
      }
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onRabattChange (): void {
      if(this.data.ZuschlagRabatt.Rabatt == null || this.data.ZuschlagRabatt.Rabatt < 0) {
        this.data.ZuschlagRabatt.Rabatt = 0.00
      }
    },

    onZuschlagChange (): void {
      if(this.data.ZuschlagRabatt.Zuschlag == null || this.data.ZuschlagRabatt.Zuschlag < 0) {
        this.data.ZuschlagRabatt.Zuschlag = 0.00
      }
    },

    onDateChange (date: string): void {
      this.dateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurProject (): void {
      this.dateFormatted = this.data.Konditionen.Datum && moment(this.data.Konditionen.Datum).isValid() ? moment(this.data.Konditionen.Datum).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onSearchAddressClick (): void {
      //this.showSearchDialog = true
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false
    },

    onSelectedAddress (data: SearchAddress): void {
      this.showSearchDialog = false
      this.address = data.genAdresse
    },

    dataValidation(): boolean {
      //@ts-ignore
      return this.$refs.form.validate()
    },

    setFocus (): void {
      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    }
  },

  mounted () {
    this.dateFormatted = this.data.Konditionen.Datum ? moment(this.data.Konditionen.Datum).format('DD.MM.YYYY') : ''

    this.setFocus()
  }
})
